/**
 * 侧边栏
 * @author fulh
 * @update 2015-01-21 20:31:16
 */
$.module('MM.fixedbar.main', function () {
  var $dialog = null,
    $dialogCnt = null,
    $bar = null,
    userInfo = null,
    TMPL = null,
    hideRight = -270,
    showRight = 70,
    gameList = []; // 联运游戏列表

  ACTIONS = {
    setOBS: '/room/edit_obs_switch/{access_token}/{room_id}?obs_switch={code}',
    feedback: 'public/feedback?content={content}&app=ttshow&f={from}&tid={tid}&contact={contact}',
    hide: 'user/vip_hiding/{access_token}/{type}',
    loveGroupInfo: 'lovegroup/group_info?access_token={access_token}',
    gameList: '/api/v5/game-permission/get/v2',
  };

  function _init() {
    TMPL = MM.fixedbar.tmpl;
    if (!$.os.desktop) {
      return;
    }

    // $("#j_fixedbar").remove();
    // $("#j_fixedbar_dialog").remove();
    $('#page').append(TMPL.fixedbar); //.addClass('ani-margin-right');

    $bar = $('#j_fixedbar');
    $dialog = $('#j_fixedbar_dialog');
    $dialogCnt = $dialog.find('.fixedbar-dialog-cnt');

    if (!MM.user.isLogin()) {
      $bar.html($.template(TMPL.fiexedBar, { app_v: 'v1', list: [] })); // v1
    } else {
      _initGameList();
      MM.user.registerExtraCallback(function () {
        userInfo = MM.user.getUserInfo();
        _renderFixedbar();
        // _renderTop();
        //MM.fixedbar.survey.init(); 侧边栏调查隐藏

        $bar.addClass('has-im');

        //<link rel="icon"href="https://dev-im.2339.com/favicon.ico"><link href="https://dev-im.2339.com/app.bf3335a9.bundle.css"rel="stylesheet"></head>
        // <body>
        // <div id="im_app"></div>
        // <script>var CURRENT_CONFIG={development:!0,mode:"development",version:"0.0.0",devServer:!1}</script>
        // <script src="https://dev-im.2339.com/static/scripts/dll/app_dll_639177.js"></script>
        // <script src="https://dev-im.2339.com/static/scripts/app.bd8bc2.bundle.js"></script>
        if (!window.inPcClient) {
          $.getJSON(MM.core.getRoot('entry.json?_t=' + Date.now(), 'chatIm'), function (res) {
            var publicPath = res.publicPath;
            // publicPath = MM.core.getRoot('/', 'chatIm')
            var css = _.map(res.entries.app.css, function (item) {
              return publicPath + item;
            });
            var js = _.map(res.entries.app.js, function (item) {
              return publicPath + item;
            });
            window.ImAppConfig = {
              inject: true,
              token: MM.user.getToken(),
            };

            MM.core.loadScriptCss({
              appStyles: css,
              isCombo: false,
            });
            MM.core.debug('init ImModule');
            $LAB
              .queueScript(js)
              .queueWait(function () {
                if (window.ImApp) {
                  ImApp.init();
                } else {
                  MM.core.debug('ImModule init error');
                }
              })
              .runQueue();
          });
        }
      });
    }
    _registerEvents();
  }

  function _renderFixedbar() {
    $bar
      .append(
        $.template(TMPL.fixedbarLogined, {
          data: userInfo,
          app_v: CURRENT_APP.v1 || gameList.length == 0 ? 'v1' : 'v2',
          list: gameList,
        }),
      )
      .addClass('fixedbar-logined');
  }

  // 渲染头部
  function _renderTop() {
    if (MM.user.isLogin() && $.os.desktop) {
      var userInfo = MM.user.getUserInfo();
    }
  }

  function _registerEvents() {
    $bar
      .click(function (e) {
        e.stopPropagation();
      })
      .delegate('.fixedbar-list li, .fixedbar-header', 'click', function (e) {
        // 右侧菜单
        var $this = $(this);
        var moduleName = $this.data('for');

        debug('moduleName : ', moduleName);

        if (moduleName === 'scrollToTop') {
          window.scrollTo(0, 0);

          return;
        }

        if (moduleName === 'pay' || moduleName === 'code') {
          return;
        }

        if ($this.data('login') && !MM.user.isLogin() && moduleName != 'ucenter') {
          MM.user.popupLogin();
          return;
        }

        if (moduleName == 'privilege') {
          MM.ui.popup.showH5('用户权益', '/app/user-rights');
          return;
        } else if (moduleName == 'accuse') {
          MM.live.accuse.show();
        } else if (moduleName === 'unionGame') {
          if (!$this.hasClass('on')) {
            $('.union-game')[0].style.visibility = 'inherit';
          } else {
            $('.union-game')[0].style.visibility = 'hidden';
          }
        }

        if (!$this.hasClass('on') && moduleName !== 'unionGame') {
          $('.union-game')[0].style.visibility = 'hidden';
        }
        if ($this.hasClass('on')) {
          $this.removeClass('on');
          $dialog.stop().animate(
            {
              right: hideRight,
            },
            300,
            function () {
              $dialog.hide();
            },
          );
          return;
        }

        $('.fixedbar-list li,.fixedbar-header').removeClass('on');
        $this.addClass('on');
        $dialog.css('right', hideRight).show();

        var controller = MM.fixedbar[moduleName];

        if (controller) {
          $('#j_fixedbar_loading').show().siblings().hide();
          $dialog.stop().animate(
            {
              right: showRight,
            },
            300,
          );
          controller.show();
        }
        return false;
      })
      .delegate('.union-game div', 'click', function (e) {
        var $this = $(this);
        var gameName = $this.data('for');
        if (gameName && typeof wwwPublic !== 'undefined') {
          $('.union-game')[0].style.visibility = 'hidden';
          $(".fixedbar-list li[data-for='unionGame']").removeClass('on');
          wwwPublic.showGame(gameName);
        }
      });

    $('#page').delegate('.fixedbar-dialog,#im-wrap', 'click', function (e) {
      e.stopPropagation();
    });
    $('body').delegate('#mask,.ui-messager-mask', 'click', function (e) {
      e.stopPropagation();
    });

    $(window).bind('resize', function () {
      _refreshNanoScroller();
    });
  }

  // 初始化游戏列表
  function _initGameList() {
    request.get({
      url: ACTIONS.gameList,
      urlType: 'cryolite',
      success: (res) => {
        let list = res.data.filter((item) => item.union == true);
        gameList = list || [];
      },
    });
  }

  function _refreshNanoScroller() {
    if ($dialog.is(':visible')) {
      $dialog.nanoScroller({
        preventPageScrolling: true,
        paneClass: 'fixedbar-dialog-pane',
        sliderClass: 'fixedbar-dialog-slider',
        contentClass: 'fixedbar-dialog-cnt',
        tabIndex: -1,
      });
    }
  }

  /**
   * 初始化弹窗
   * @param  {string}  html    内容
   * @param  {Boolean} hasHeader 是否有头部
   * @param  {string}  moduleID  模块ID key
   * @param  {Boolean} isShow    是否直接显示
   */
  function _initDialog(html, hasHeader, moduleID, isShow) {
    if (moduleID != 'friend') {
      $('#j_fixedbar_' + moduleID).remove();
      $dialogCnt.append(html);
    }
    hasHeader = false;
    $('#j_fixedbar_dialog_hd').hide();
    if (hasHeader) {
      $dialog.addClass('dialog-has-hd');
      $('#j_fixedbar_dialog_hd')
        .html(
          $('#j_fixedbar_' + moduleID)
            .find('.fixedbar-dialog-hd')
            .html(),
        )
        .find('h2')
        .addClass('fixedbar-dialog-hd-' + moduleID);
    } else {
      $dialog.removeClass('dialog-has-hd');
    }
    if (isShow) {
      _showDialog(moduleID);
    }
  }

  function _showDialog(moduleID) {
    $('#j_fixedbar_' + moduleID)
      .show()
      .siblings()
      .hide();
    $dialog.attr('data-module', moduleID);
    _refreshNanoScroller();
  }

  function _track(action) {
    MM.common.track('边栏', action);
  }

  /**
   * 判断是否在档案页
   * @return {Boolean} [description]
   */
  function _isArchivePage() {
    return /\/u\//.test(location.href);
  }

  return {
    init: _init,
    initDialog: _initDialog,
    showDialog: _showDialog,
    isArchivePage: _isArchivePage,
    scrollRefresh: function () {
      _refreshNanoScroller();
    },
    renderTop: _renderTop,
    track: _track,
  };
});

$(function () {
  if ($.os.desktop) {
    // setTimeout(function () {
    //对广播初始化有影响
    // MM.fixedbar.main.init();
    // },1000);
  }
});
